import {useParams} from "react-router-dom";
import {ChangesetContext} from "./ChangesetContext";
import {useContext} from "react";

export function useChangesetId() {
    const params = useParams<{changesetId: string}>();
    const ctx = useContext(ChangesetContext);

    if(ctx.sessionId) return ctx.sessionId;

    try {
        if(!params.changesetId) return 0;

        const id = parseInt(params.changesetId, 10)
        if(isNaN(id)) return 0;

        return id;
    } catch (e) {
        return 0;
    }
}